export default "__VITE_ASSET__0bca8025__"